export const MenuItem = {
  divider: 'MENU_DIVIDER'
};